interface IProps {
    min: number
    value: number
    max: number
}

export default function within({ min, value, max }: IProps) {
    return Math.max(min, Math.min(value, max))
}
